import { Theme } from '@chakra-ui/react';

const defaultFontFamily = 'Inter, Helvetica, Arial, sans-serif !important';

export const fonts: Theme['fonts'] = {
  body: defaultFontFamily,
  mono: defaultFontFamily,
  heading: defaultFontFamily,
};
